import { Platform, StyleSheet } from 'react-native';
import { FontFamily } from '../../../../constants/fonts';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f5f9ff',
  },
  contentContainer: {
    paddingBottom: 40,
  },
  breadcrumbWrap: {
    marginHorizontal: 24,
    marginTop: 12,
  },
  header: {
    marginHorizontal: 24,
    marginTop: 10,
    marginBottom: 14,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    flexWrap: 'wrap',
  },
  headerLeft: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
  },
  headerIconWrap: {
    width: 40,
    height: 40,
    borderRadius: 8,
    backgroundColor: '#E8F1FD',
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: {
    fontSize: 24,
    fontWeight: '700',
    fontFamily: FontFamily.bold,
    color: '#1A1D21',
  },
  subtitle: {
    fontSize: 12,
    color: '#6B7280',
    fontFamily: FontFamily.regular,
  },
  refreshedBadge: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  headerMetaRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    flexWrap: 'wrap',
  },
  headerMetaSeparator: {
    fontSize: 12,
    color: '#A3A8B3',
    marginHorizontal: 8,
    fontFamily: FontFamily.regular,
  },
  refreshedBadgeText: {
    fontSize: 12,
    fontWeight: '400',
    fontFamily: FontFamily.regular,
    color: '#4B5563',
  },
  refreshedBadgeValueText: {
    fontSize: 12,
    fontWeight: '700',
    fontFamily: FontFamily.bold,
    color: '#005CBC',
  },
  mobileFilterTriggerRow: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    paddingHorizontal: 24,
    marginBottom: 12,
  },
  mobileFilterButton: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#034895',
    borderRadius: 24,
    paddingVertical: 4,
    paddingHorizontal: 16,
    height: 32,
    gap: 4,
  },
  mobileFilterButtonText: {
    fontSize: 14,
    fontWeight: '700',
    color: '#FFFFFF',
    lineHeight: 20,
    fontFamily: FontFamily.bold,
  },
  filterBarWrapper: {
    paddingHorizontal: 24,
    paddingTop: 4,
    paddingBottom: 16,
  },
  filterBar: {
    backgroundColor: '#FFFFFF',
    borderRadius: 12,
    borderWidth: 1,
    borderColor: '#E3E9F3',
    paddingHorizontal: 14,
    paddingVertical: 12,
    shadowColor: '#A8B4C5',
    shadowOpacity: 0.08,
    shadowRadius: 6,
    shadowOffset: { width: 0, height: 2 },
    elevation: 2,
  },
  filtersRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'flex-end',
    gap: 8,
    rowGap: 14,
  },
  filterGroup: {
    flexDirection: 'row',
    flexWrap: 'nowrap',
    alignItems: 'flex-end',
    gap: 8,
    flexShrink: 1,
    minWidth: 0,
  },
  filterGroupTwo: {
    flex: 2,
  },
  filterGroupThree: {
    flex: 3,
  },
  filterGroupSeparator: {
    width: 1,
    alignSelf: 'stretch',
    minHeight: 56,
    backgroundColor: '#E5EAF3',
  },
  filterItem: {
    flex: 1,
    minWidth: 0,
  },
  filterLabel: {
    fontSize: 10,
    fontWeight: '700',
    fontFamily: FontFamily.bold,
    color: '#6A6D71',
    letterSpacing: 0.2,
    textTransform: 'uppercase',
  },
  filterLabelRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    marginBottom: 6,
  },
  filterBarMainRow: {
    flexDirection: 'row',
    alignItems: 'stretch',
    gap: 12,
  },
  filtersTwoRowArea: {
    flex: 19,
    gap: 12,
  },
  filterActionsColumn: {
    flex: 1,
    flexDirection: 'column',
    alignItems: 'stretch',
    justifyContent: 'center',
    gap: 8,
    paddingLeft: 8,
    borderLeftWidth: 1,
    borderLeftColor: '#E5EAF3',
  },
  filterActionsRow: {
    marginTop: 10,
    flexDirection: 'row',
    justifyContent: 'flex-end',
    width: '100%',
  },
  filterActions: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    paddingBottom: 0,
    paddingTop: 0,
  },
  resetBtn: {
    borderWidth: 1,
    borderColor: '#0B5FC6',
    paddingHorizontal: 14,
    paddingVertical: 8,
    borderRadius: 8,
    backgroundColor: '#FFFFFF',
    minHeight: 34,
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
  resetBtnText: {
    fontSize: 12,
    fontFamily: FontFamily.bold,
    color: '#0B5FC6',
  },
  applyBtn: {
    paddingHorizontal: 14,
    paddingVertical: 8,
    borderRadius: 8,
    minHeight: 34,
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
  applyBtnEnabled: {
    backgroundColor: '#0B5FC6',
  },
  applyBtnDisabled: {
    backgroundColor: '#D0D5DD',
  },
  applyBtnText: {
    fontSize: 12,
    fontFamily: FontFamily.bold,
    color: '#9CA3AF',
  },
  applyBtnTextEnabled: {
    color: '#FFFFFF',
  },
  quickTimeFrameRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: 8,
    marginTop: 12,
    paddingTop: 12,
    borderTopWidth: 1,
    borderTopColor: '#EEF2F7',
  },
  quickTimeFrameLabel: {
    fontSize: 10,
    fontWeight: '700',
    fontFamily: FontFamily.bold,
    color: '#6A6D71',
    letterSpacing: 0.2,
    textTransform: 'uppercase',
    marginRight: 2,
  },
  quickTimeFrameBtn: {
    height: 28,
    paddingHorizontal: 12,
    borderRadius: 14,
    borderWidth: 1,
    borderColor: '#D0D5DD',
    backgroundColor: '#FFFFFF',
    justifyContent: 'center',
  },
  quickTimeFrameBtnActive: {
    backgroundColor: '#005CBC',
    borderColor: '#005CBC',
  },
  quickTimeFrameBtnDisabled: {
    opacity: 0.5,
  },
  quickTimeFrameBtnText: {
    fontSize: 11.5,
    fontFamily: FontFamily.bold,
    color: '#4B5563',
  },
  quickTimeFrameBtnTextActive: {
    color: '#FFFFFF',
  },
  tabBar: {
    marginHorizontal: 24,
    marginTop: 4,
    borderBottomWidth: 1,
    borderBottomColor: '#E5E7EB',
  },
  tabBarContent: {
    flexDirection: 'row',
    alignItems: 'center',
    columnGap: 12,
    paddingBottom: 0,
  },
  tab: {
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderBottomWidth: 2,
    borderBottomColor: 'transparent',
  },
  tabActive: {
    borderBottomColor: '#005CBC',
  },
  tabLabel: {
    fontSize: 14,
    color: '#6B7280',
    fontFamily: FontFamily.medium,
    fontWeight: '700',
  },
  tabLabelActive: {
    color: '#005CBC',
    fontFamily: FontFamily.bold,
    fontWeight: '700',
  },
  tabContentContainer: {
    paddingHorizontal: 20,
    paddingTop: 14,
    paddingBottom: 10,
  },
  sectionGap: {
    rowGap: 16,
  },
  kpiRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 12,
  },
  kpiCard: {
    flexGrow: 1,
    minWidth: 210,
    backgroundColor: '#FFFFFF',
    borderRadius: 10,
    borderWidth: 1,
    borderColor: '#E5EAF3',
    paddingHorizontal: 16,
    paddingVertical: 14,
    ...(Platform.OS === 'web' ? {
      boxShadow: '0px 1px 3px rgba(27, 31, 37, 0.12), 0px 1px 2px rgba(27, 31, 37, 0.24)',
      transitionProperty: 'box-shadow, border-color, background-color, transform',
      transitionDuration: '150ms',
    } : null),
  },
  kpiCardHover: {
    boxShadow: '0 4px 20px rgba(0, 94, 192, 0.14)',
    transform: [{ translateY: -1 }],
    borderColor: '#82CDF8',
  },
  kpiLabelRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
  },
  kpiLabel: {
    fontSize: 11,
    fontFamily: FontFamily.bold,
    color: '#6B7280',
    textTransform: 'uppercase',
    letterSpacing: 0.25,
  },
  kpiInfoIconButton: {
    padding: 0,
    margin: 0,
  },
  kpiInfoIcon: {
    width: 16,
    height: 16,
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#EEF4FB',
  },
  kpiInfoIconText: {
    fontSize: 11,
    lineHeight: 11,
    fontFamily: FontFamily.bold,
    color: '#005CBC',
    marginTop: 1,
  },
  kpiValue: {
    marginTop: 6,
    fontSize: 30,
    lineHeight: 34,
    color: '#1F2937',
    fontFamily: FontFamily.bold,
  },
  kpiValueSuccess: {
    color: '#0D7A39',
  },
  kpiValueWarning: {
    color: '#8A6500',
  },
  kpiValueDanger: {
    color: '#C43A17',
  },
  kpiSubLabel: {
    marginTop: 4,
    fontSize: 12,
    color: '#6B7280',
    fontFamily: FontFamily.regular,
  },
  card: {
    backgroundColor: '#FFFFFF',
    borderRadius: 10,
    borderWidth: 1,
    borderColor: '#E5EAF3',
    padding: 16,
  },
  cardHeader: {
    marginBottom: 10,
  },
  cardHeaderRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 10,
    marginBottom: 10,
  },
  exportBtn: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5,
    height: 28,
    paddingHorizontal: 10,
    borderRadius: 6,
    borderWidth: 1,
    borderColor: '#D0D5DD',
    backgroundColor: '#FFFFFF',
  },
  exportBtnText: {
    fontSize: 11.5,
    fontFamily: FontFamily.bold,
    color: '#4B5563',
  },
  cardTitle: {
    fontSize: 18,
    color: '#1F2937',
    fontFamily: FontFamily.bold,
  },
  cardSubTitle: {
    marginTop: 2,
    fontSize: 12,
    color: '#6B7280',
    fontFamily: FontFamily.regular,
  },
  tableWrap: {
    width: '100%',
    borderWidth: 0,
    borderRadius: 0,
    overflow: 'hidden',
  },
  salesTableWrap: {
    minWidth: 1680,
  },
  customerTableWrap: {
    minWidth: 0,
  },
  skuTableWrap: {
    width: '100%',
    minWidth: 0,
  },
  maxPotentialExecutionTableWrap: {
    minWidth: 1895,
  },
  recoTableWrap: {
    minWidth: 2990,
  },
  recoVerticalScroll: {
    maxHeight: 520,
  },
  openRecoTableWrap: {
    width: '100%',
  },
  tableHeaderRow: {
    flexDirection: 'row',
    backgroundColor: '#F5F8FD',
    borderBottomWidth: 1,
    borderBottomColor: '#DDE6F4',
  },
  tableHeaderCell: {
    paddingHorizontal: 12,
    paddingVertical: 10,
    justifyContent: 'center',
    flexDirection: 'row',
    alignItems: 'center',
  },
  tableHeaderText: {
    fontSize: 11,
    letterSpacing: 0.25,
    textTransform: 'uppercase',
    color: '#6B7280',
    fontFamily: FontFamily.bold,
    flexShrink: 1,
  },
  tableHeaderSortIcon: {
    marginLeft: 2,
    flexShrink: 0,
  },
  // maxPotentialHeaderSortIcon: {
  //   marginLeft: 10,
  // },
  tableHeaderCellAlignRight: {
    justifyContent: 'flex-end',
  },
  tableHeaderCellAlignCenter: {
    justifyContent: 'center',
  },
  tableDataRow: {
    flexDirection: 'row',
    alignItems: 'center',
    minHeight: 44,
    borderBottomWidth: 1,
    borderBottomColor: '#EEF2F7',
    backgroundColor: '#FFFFFF',
  },
  tableDataRowHover: {
    backgroundColor: '#E7EFFB',
  },
  tableDataCell: {
    paddingHorizontal: 12,
    paddingVertical: 11,
    justifyContent: 'center',
    alignSelf: 'stretch',
  },
  openRecoCell: {
    paddingHorizontal: 12,
    paddingVertical: 11,
    justifyContent: 'center',
  },
  openRecoCellSortHeader: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  tableDataText: {
    fontSize: 13,
    lineHeight: 18,
    color: '#1F2937',
    fontFamily: FontFamily.regular,
  },
  tableDataTextStrong: {
    fontFamily: FontFamily.bold,
  },
  tableLinkText: {
    fontSize: 13,
    color: '#005CBC',
    fontFamily: FontFamily.bold,
  },
  tableMutedText: {
    fontSize: 13,
    color: '#838383',
    fontFamily: FontFamily.regular,
  },
  utilizationHeaderActions: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  utilizationColumnsBtn: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5,
    height: 28,
    paddingHorizontal: 10,
    borderRadius: 6,
    borderWidth: 1,
    borderColor: '#D0D5DD',
    backgroundColor: '#FFFFFF',
  },
  utilizationColumnsBtnText: {
    fontSize: 11.5,
    fontFamily: FontFamily.bold,
    color: '#4B5563',
  },
  utilizationColumnsPanel: {
    marginTop: 12,
    marginBottom: 14,
    padding: 14,
    borderWidth: 1,
    borderColor: '#E3E9F3',
    borderRadius: 8,
    backgroundColor: '#F8FAFD',
    rowGap: 12,
  },
  utilizationColumnGroup: {
    rowGap: 8,
  },
  utilizationColumnGroupTitle: {
    fontSize: 11,
    fontFamily: FontFamily.bold,
    color: '#005CBC',
    textTransform: 'uppercase',
    letterSpacing: 0.3,
  },
  utilizationColumnOptionsRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    columnGap: 20,
    rowGap: 8,
  },
  utilizationColumnOption: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 7,
  },
  utilizationColumnOptionText: {
    fontSize: 13,
    color: '#1F2937',
    fontFamily: FontFamily.regular,
  },
  utilizationColumnsNote: {
    fontSize: 11.5,
    color: '#818181',
    fontFamily: FontFamily.regular,
    fontStyle: 'italic',
    marginTop: 4,
  },
  utilizationColumnsModalSubtitle: {
    fontSize: 12.5,
    color: '#6B7280',
    fontFamily: FontFamily.regular,
    marginBottom: 14,
  },
  utilizationColsOverlay: {
    flex: 1,
  },
  utilizationColsInlineBackdrop: {
    position: 'absolute',
    top: -9999,
    left: -9999,
    right: -9999,
    bottom: -9999,
    zIndex: 998,
  },
  utilizationColsPopover: {
    position: 'absolute',
    width: 460,
    maxWidth: '92%',
    backgroundColor: '#FFFFFF',
    borderRadius: 12,
    borderWidth: 1,
    borderColor: '#E3E8EF',
    padding: 18,
    ...(Platform.OS === 'web'
      ? { boxShadow: '0 16px 40px rgba(16, 24, 40, 0.16)' }
      : {
          shadowColor: '#101828',
          shadowOpacity: 0.16,
          shadowRadius: 20,
          shadowOffset: { width: 0, height: 8 },
          elevation: 8,
        }),
  },
  utilizationColsPopoverTitle: {
    fontSize: 15,
    fontFamily: FontFamily.bold,
    color: '#1F2937',
    marginBottom: 3,
  },
  utilizationColsActionsRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 14,
    marginBottom: 12,
  },
  utilizationColsActionsSide: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 11,
  },
  utilizationColsActionBtn: {
    fontSize: 12.5,
    fontFamily: FontFamily.bold,
    color: '#005CBC',
  },
  utilizationColsActionBtnDisabled: {
    color: '#B0B8C4',
  },
  utilizationColsActionDivider: {
    width: 1,
    height: 13,
    backgroundColor: '#D0D0D0',
  },
  utilizationGroupCard: {
    borderWidth: 1,
    borderColor: '#E3E8EF',
    borderRadius: 8,
    overflow: 'hidden',
    marginBottom: 10,
    backgroundColor: '#FFFFFF',
  },
  utilizationGroupCardHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 14,
    paddingVertical: 10,
    backgroundColor: '#EFF4FD',
  },
  utilizationGroupCardTitle: {
    fontSize: 12,
    fontFamily: FontFamily.bold,
    color: '#005CBC',
    letterSpacing: 0.3,
  },
  utilizationGroupCardBody: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    columnGap: 16,
    rowGap: 12,
    padding: 14,
  },
  utilizationColumnOption2: {
    width: '45%',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  utilizationQuickFilterChip: {
    flexDirection: 'row',
    alignItems: 'center',
    alignSelf: 'flex-start',
    gap: 3,
    maxWidth: '100%',
  },
  utilizationQuickFilterChipActive: {
    backgroundColor: '#EFF5FC',
    borderRadius: 4,
    paddingHorizontal: 7,
    paddingVertical: 2,
  },
  utilizationQuickFilterText: {
    fontSize: 13,
    color: '#005CBC',
    fontFamily: FontFamily.bold,
  },
  utilizationQuickFilterTextActive: {
    color: '#005CBC',
  },
  customerPerfCell: {
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 10,
  },
  customerPerfTrack: {
    width: 70,
    height: 6,
    borderRadius: 999,
    backgroundColor: '#E6E6E6',
    overflow: 'hidden',
  },
  customerPerfFill: {
    height: '100%',
    borderRadius: 999,
  },
  customerPerfValue: {
    minWidth: 30,
    fontSize: 13,
    fontFamily: FontFamily.bold,
  },
  customerPerfValueAboveTarget: {
    color: '#005CBC',
  },
  customerPerfValueBelowTarget: {
    color: '#C12C01',
  },
  tableNeutralTag: {
    paddingHorizontal: 8,
    height: 24,
    borderRadius: 4,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#E6E6E6',
  },
  tableNeutralTagText: {
    fontSize: 12,
    color: '#4B4B4B',
    fontFamily: FontFamily.medium,
  },
  alignRight: {
    alignItems: 'flex-end',
  },
  alignCenter: {
    alignItems: 'center',
  },
  badge: {
    height: 24,
    borderRadius: 4,
    paddingHorizontal: 8,
    alignItems: 'center',
    justifyContent: 'center',
  },
  badgeText: {
    fontSize: 12,
    fontFamily: FontFamily.bold,
  },
  emptyStateWrap: {
    minHeight: 130,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1,
    borderColor: '#E5EAF3',
    borderRadius: 8,
    backgroundColor: '#FFFFFF',
  },
  emptyStateText: {
    fontSize: 13,
    color: '#6B7280',
    fontFamily: FontFamily.medium,
    textAlign: 'center',
    paddingHorizontal: 20,
  },
  maxPotentialMetricRow: {
    flexWrap: 'nowrap',
  },
  maxPotentialMetricLabelRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  maxPotentialInfoBtn: {
    width: 18,
    height: 18,
    borderRadius: 9,
    alignItems: 'center',
    justifyContent: 'center',
  },
  maxPotentialHeaderCell: {
    paddingHorizontal: 10,
    paddingVertical: 10,
    minHeight: 42,
  },
  maxPotentialHeaderTextWrap: {
    flex: 1,
    minWidth: 0,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 2,
  },
  maxPotentialHeaderText: {
    fontSize: 11,
    lineHeight: 14,
    textAlign: 'center',
    flexShrink: 1,
  },
  maxPotentialHeaderInfoIcon: {
    paddingTop: 1,
    width: 14,
    height: 14,
    alignItems: 'center',
    justifyContent: 'center',
  },
  maxPotentialToggleCard: {
    paddingVertical: 14,
    paddingHorizontal: 24,
  },
  maxPotentialToggleRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: 10,
  },
  maxPotentialSwitchTrack: {
    width: 38,
    height: 20,
    borderRadius: 999,
    backgroundColor: '#C0C0C0',
    padding: 2,
  },
  maxPotentialSwitchTrackOn: {
    backgroundColor: '#005CBC',
  },
  maxPotentialSwitchThumb: {
    width: 16,
    height: 16,
    borderRadius: 8,
    backgroundColor: '#FFFFFF',
  },
  maxPotentialSwitchThumbOn: {
    transform: [{ translateX: 18 }],
  },
  maxPotentialToggleLabel: {
    fontSize: 13,
    color: '#4B5563',
    fontFamily: FontFamily.medium,
  },
  maxPotentialToggleDescription: {
    marginLeft: 'auto',
    flexShrink: 1,
    fontSize: 12,
    color: '#838383',
    fontFamily: FontFamily.regular,
  },
  orderRuleCheckToggleCard: {
    paddingVertical: 14,
    paddingHorizontal: 16,
  },
  orderRuleCheckToggleRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    columnGap: 24,
    rowGap: 10,
    flexWrap: 'wrap',
  },
  orderRuleCheckToggleItem: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
  },
  orderRuleCheckToggleLabel: {
    fontSize: 13,
    color: '#4B5563',
    fontFamily: FontFamily.medium,
  },
  // Dims a toggle while its mutually-exclusive sibling is on.
  orderRuleCheckToggleDisabled: {
    opacity: 0.45,
  },
  orderRuleCheckToggleLabelDisabled: {
    color: '#9CA3AF',
  },
  orderRuleCheckInfoBtn: {
    width: 18,
    height: 18,
    borderRadius: 9,
    alignItems: 'center',
    justifyContent: 'center',
  },
  orderRuleCheckBuildWrap: {
    minWidth: 1470,
  },
  // Clips the single horizontal ScrollView (header + body) to the card's
  // width so the table scrolls in place instead of overflowing the page.
  orderRuleCheckTableClip: {
    width: '100%',
    overflow: 'hidden',
    borderRadius: 8,
  },
  orderRuleCheckCrossdockWrap: {
    minWidth: 1220,
  },
  orderRuleFlagWrap: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 6,
    flexWrap: 'wrap',
    width: '100%',
  },
  orderRuleFlagChip: {
    minHeight: 22,
    borderRadius: 3,
    paddingHorizontal: 8,
    alignItems: 'center',
    justifyContent: 'center',
  },
  orderRuleFlagReview: {
    backgroundColor: '#FEE2E2',
  },
  orderRuleFlagOk: {
    backgroundColor: '#DCFCE7',
  },
  orderRuleFlagChipText: {
    fontSize: 11,
    lineHeight: 14,
    fontFamily: FontFamily.bold,
  },
  orderRuleFlagReviewText: {
    color: '#B42318',
  },
  orderRuleFlagOkText: {
    color: '#067647',
  },
  orderRuleFlagSecondaryChip: {
    backgroundColor: '#EEF2F7',
  },
  orderRuleFlagSecondaryText: {
    color: '#475467',
  },
  orderRuleReviewActionBtn: {
    height: 26,
    borderRadius: 4,
    backgroundColor: '#EFF5FC',
    paddingHorizontal: 10,
    alignItems: 'center',
    justifyContent: 'center',
  },
  orderRuleReviewActionBtnText: {
    fontSize: 12,
    color: '#005CBC',
    fontFamily: FontFamily.bold,
  },
  orderRuleReviewActionBtnDisabled: {
    opacity: 0.55,
  },
  orderRuleReviewActionWrap: {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 4,
  },
  orderRuleReviewActionRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
  },
  orderRuleReviewAcceptedBadge: {
    minHeight: 22,
    borderRadius: 4,
    paddingHorizontal: 8,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#CBEFC9',
  },
  orderRuleReviewAcceptedBadgeText: {
    fontSize: 11,
    color: '#067647',
    fontFamily: FontFamily.bold,
  },
  orderRuleReviewUndoText: {
    fontSize: 11,
    color: '#667085',
    textDecorationLine: 'underline',
    fontFamily: FontFamily.medium,
  },
  orderRuleReviewMetaText: {
    fontSize: 10,
    color: '#98A2B3',
    fontFamily: FontFamily.regular,
    textAlign: 'center',
  },
  maxPotentialLadderToggle: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    alignSelf: 'flex-start',
  },
  maxPotentialLadderToggleText: {
    fontSize: 14,
    color: '#005CBC',
    fontFamily: FontFamily.bold,
  },
  maxPotentialGuideLadder: {
    flexDirection: 'row',
    flexWrap: 'nowrap',
    columnGap: 16,
    rowGap: 0,
  },
  maxPotentialGuideStep: {
    flex: 1,
    minWidth: 0,
    borderRadius: 8,
    backgroundColor: '#E8F1FD',
    borderWidth: 1,
    borderColor: '#D5E5FB',
    paddingHorizontal: 16,
    paddingVertical: 14,
    position: 'relative',
  },
  maxPotentialGuideStepTitle: {
    fontSize: 13,
    color: '#0B5FC6',
    fontFamily: FontFamily.bold,
  },
  maxPotentialGuideStepBody: {
    marginTop: 4,
    fontSize: 12,
    lineHeight: 17,
    color: '#4B5563',
    fontFamily: FontFamily.regular,
  },
  maxPotentialGuideArrow: {
    position: 'absolute',
    right: '-5%',
    top: '48%',
    zIndex: 5,
  },
  maxPotentialChildRow: {
    backgroundColor: '#EFF5FC',
  },
  maxPotentialBuildLocationWrap: {
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
  },
  maxPotentialRowToggleBtn: {
    width: 18,
    height: 18,
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 6,
  },
  maxPotentialRowToggleIconOpen: {
    transform: [{ rotate: '90deg' }],
  },
  maxPotentialRowToggleIconDisabled: {
    opacity: 0.3,
  },
  maxPotentialChildLocationWrap: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    width: '100%',
  },
  maxPotentialChildTag: {
    borderWidth: 1,
    borderColor: '#C0C0C0',
    borderRadius: 3,
    paddingHorizontal: 5,
    paddingVertical: 2,
  },
  maxPotentialChildTagText: {
    fontSize: 9,
    letterSpacing: 0.3,
    color: '#838383',
    textTransform: 'uppercase',
    fontFamily: FontFamily.bold,
  },
  maxPotentialPositiveText: {
    color: '#005CBC',
  },
  maxPotentialNegativeText: {
    color: '#C12C01',
  },
  maxPotentialGapText: {
    color: '#995211',
  },
  mobileOverlayContainer: {
    flex: 1,
    backgroundColor: '#FFFFFF',
  },
  mobileOverlayBody: {
    flex: 1,
  },
  mobileOverlayBodyContent: {
    paddingHorizontal: 16,
    paddingTop: 16,
    paddingBottom: 24,
  },
  mobileOverlayFooter: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 10,
    paddingHorizontal: 16,
    paddingTop: 12,
    paddingBottom: 20,
    borderTopWidth: 1,
    borderTopColor: '#E5E7EB',
    backgroundColor: '#FFFFFF',
  },
  mobileOverlayCancelBtn: {
    flex: 1,
    minHeight: 42,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#D0D5DD',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#FFFFFF',
  },
  mobileOverlayCancelBtnText: {
    fontSize: 14,
    color: '#344054',
    fontFamily: FontFamily.bold,
  },
  mobileOverlayResetBtn: {
    flex: 1,
    minHeight: 42,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#0B5FC6',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#FFFFFF',
  },
  mobileOverlayResetBtnText: {
    fontSize: 14,
    color: '#0B5FC6',
    fontFamily: FontFamily.bold,
  },
  mobileOverlayApplyBtn: {
    flex: 1,
    minHeight: 42,
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#0B5FC6',
  },
  mobileOverlayApplyBtnText: {
    fontSize: 14,
    color: '#FFFFFF',
    fontFamily: FontFamily.bold,
  },
  errorModalMessage: {
    fontSize: 16,
    color: '#3A3A3A',
    lineHeight: 24,
    textAlign: 'center',
    marginVertical: 10,
    fontFamily: FontFamily.regular,
  },
  // ── Pagination ───────────────────────────────────────────────────────────────
  paginationRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderTopWidth: 1,
    borderTopColor: '#E8EDF6',
    marginTop: 4,
  },
  paginationLabel: {
    fontSize: 12,
    color: '#6B7280',
    fontFamily: FontFamily.regular,
  },
  utilizationGroupingNote: {
    fontSize: 12,
    color: '#6B7280',
    fontFamily: FontFamily.regular,
    paddingHorizontal: 16,
    paddingBottom: 12,
  },
  paginationBtnGroup: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  paginationBtn: {
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 6,
    backgroundColor: '#005CBC',
  },
  paginationBtnDisabled: {
    backgroundColor: '#E8EDF6',
  },
  paginationBtnText: {
    fontSize: 12,
    fontWeight: '600',
    fontFamily: FontFamily.medium,
    color: '#FFFFFF',
  },
  paginationBtnTextDisabled: {
    color: '#9CA3AF',
  },
  paginationPageText: {
    fontSize: 12,
    color: '#374151',
    fontFamily: FontFamily.regular,
    minWidth: 90,
    textAlign: 'center',
  },
  paginationSizeSelector: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
  },
  paginationSizeOption: {
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 4,
    borderWidth: 1,
    borderColor: '#DEE2E6',
    backgroundColor: '#FFFFFF',
  },
  paginationSizeOptionActive: {
    borderColor: '#005CBC',
    backgroundColor: '#EBF3FF',
  },
  paginationSizeText: {
    fontSize: 11,
    fontFamily: FontFamily.regular,
    color: '#6B7280',
  },
  paginationSizeTextActive: {
    fontFamily: FontFamily.bold,
    color: '#005CBC',
  },
});

export default styles;
